import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { formatDate } from '@ngsos/portal-core/time';
import type { DateFormatType, DateInput } from '@ngsos/portal-core/time';

export type { DateFormatType } from '@ngsos/portal-core/time';

export type DateFormatterProps = {
  date: DateInput;
  formatType?: DateFormatType;
  updateIntervalMs?: number;
};

export function DateFormatter({ date, formatType = 'calendar', updateIntervalMs }: DateFormatterProps) {
  const { i18n } = useTranslation();
  const [, setTick] = useState(0);

  useEffect(() => {
    if (updateIntervalMs == null) {
      return;
    }

    const timer = window.setInterval(() => setTick((tick) => tick + 1), updateIntervalMs);
    return () => window.clearInterval(timer);
  }, [updateIntervalMs]);

  return <>{formatDate(date, formatType, i18n.language || 'en')}</>;
}
